import React, { useState, useEffect } from 'react';
import './CareerForm.css';

import { Heading, PageTitle } from '../../../components';

import { FaUser, FaEnvelope, FaPhone, FaBriefcase, FaGraduationCap, FaMapMarkedAlt, FaLeaf, FaTree } from 'react-icons/fa';
import axios from "axios";

const API_PATH = 'https://www.example.com/api/phpmailer/career.php';
const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
const PHONE_REGEX = /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/;

const CareerForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        number: '',
        position: '',
        location: '',
        education: '',
        experience: '',
        message: ''
    });
    const [mailSent, setMailSent] = useState(false);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (mailSent) {
            const timer = setTimeout(() => setMailSent(false), 3000);
            return () => clearTimeout(timer);
        }
    }, [mailSent]);

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError('');

        try {
            const validationErrors = [];

            if (!formData.name.trim()) validationErrors.push('Imię i nazwisko jest wymagane');
            if (!formData.email.trim()) {
                validationErrors.push('Email jest wymagany');
            } else if (!EMAIL_REGEX.test(formData.email)) {
                validationErrors.push('Nieprawidłowy format email');
            }
            if (!formData.number.trim()) {
                validationErrors.push('Numer telefonu jest wymagany');
            } else if (!PHONE_REGEX.test(formData.number)) {
                validationErrors.push('Błędny format numeru telefonu');
            }
            if (!formData.position.trim()) validationErrors.push('Wymagane jest wpisanie stanowiska');
            if (!formData.location.trim()) validationErrors.push('Wymagana jest lokalizacja/forma współpracy');
            if (!formData.message.trim()) validationErrors.push('Wiadomość jest wymagana');

            if (validationErrors.length > 0) {
                throw new Error(validationErrors.join(' | '));
            }

            const postData = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                postData.append(key, value);
            });

            const response = await axios.post(API_PATH, postData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (!response.data.sent) {
                throw new Error(response.data.message || 'Udało się wysłać zgłoszenie');
            }

            setMailSent(true);
            setFormData({
                name: '',
                email: '',
                number: '',
                position: '',
                location: '',
                education: '',
                experience: '',
                message: ''
            });
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Błąd wysyłania, spróbuj ponownie');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <>
            <PageTitle title={'Formularz Rekrutacyjny'} page={'Kariera'} />

            <section className="career-form green-bg">
                <div className="box-container">
                    <div className="content">
                        <form className="dark-form" onSubmit={handleSubmitForm}>
                            <Heading title={'Dołącz do nas!'} subTitle={'Zrób pierwszy krok. Resztę zrobimy razem.'} sideHeading linear />

                            <div className="input-box">
                                <div className="input-field">
                                    <label htmlFor="name"><FaUser /></label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="box"
                                        id="name"
                                        placeholder="Imię i nazwisko"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>

                                <div className="input-field">
                                    <label htmlFor="email"><FaEnvelope /></label>
                                    <input
                                        type="email"
                                        name="email"
                                        className="box"
                                        id="email"
                                        placeholder="Adres email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>
                            </div>

                            <div className="input-box">
                                <div className="input-field">
                                    <label htmlFor="number"><FaPhone /></label>
                                    <input
                                        type="number"
                                        name="number"
                                        className="box"
                                        id="number"
                                        placeholder="Numer telefonu"
                                        value={formData.number}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>

                                {/* ZMIANA: Zamiast selecta jest teraz zwykły input */}
                                <div className="input-field">
                                    <label htmlFor="position"><FaBriefcase /></label>
                                    <input
                                        type="text"
                                        name="position"
                                        className="box"
                                        id="position"
                                        placeholder="Interesujące Cię stanowisko"
                                        value={formData.position}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>
                            </div>

                            <div className="input-box">
                                <div className="input-field">
                                    <label htmlFor="location"><FaMapMarkedAlt /></label>
                                    <input
                                        type="text"
                                        name="location"
                                        className="box"
                                        id="location"
                                        placeholder="Preferowana lokalizacja / Tryb pracy"
                                        value={formData.location}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>
                            </div>

                            <div className="input-box">
                                <div className="input-field">
                                    <label htmlFor="education"><FaGraduationCap /></label>
                                    <input
                                        type="text"
                                        name="education"
                                        className="box"
                                        id="education"
                                        placeholder="Wykształcenie / Kwalifikacje"
                                        value={formData.education}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>

                                <div className="input-field">
                                    <label htmlFor="experience"><FaTree /></label>
                                    <input
                                        type="number"
                                        name="experience"
                                        className="box"
                                        id="experience"
                                        placeholder="Lata doświadczenia"
                                        value={formData.experience}
                                        onChange={handleInputChange}
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>
                            </div>

                            <div className="input-field text-area">
                                <label htmlFor="message"><FaLeaf /></label>
                                <textarea
                                    cols="30"
                                    rows="6"
                                    name="message"
                                    className="box"
                                    id="message"
                                    placeholder="Napisz, dlaczego chcesz do nas dołączyć!"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    required
                                    disabled={isSubmitting}
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                className="btn green-btn"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Wysyłanie...' : 'Aplikuj teraz'}
                            </button>

                            {error && (
                                <div className="alert error">
                                    {error.split(' | ').map((msg, i) => (
                                        <span key={i}>{msg}</span>
                                    ))}
                                </div>
                            )}
                            {mailSent && <div className="alert success"><span>Zgłoszenie zostało wysłane pomyślnie</span></div>}
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
}

export default CareerForm;